/* ---------------------------------------------------------------
   RMS · VITRIN KARTI BASLIGI — SATIR AYRAC'TAN BOLUNUR
   24 Eylul 2026

   Baslik "<kadran rengi> · <kaplama>" bicimindedir ve 14px'te ~238px
   yer kaplar; kart 192px. Tek satira sigmaz. Tarayicinin kendi satir
   bolmesi cirkin sonuc veriyordu ('&' ile baslayan satir, tek basina
   kalan 'Kaplama'). Burada satir tam AYRACTAN bolunuyor; parcalarin
   ici bolunmez. Boylece her kart ayni iki satirlik kaliba oturuyor.

   Metin degismiyor — yalnizca nerede bolunecegi belirleniyor.
   --------------------------------------------------------------- */
(function () {
  'use strict';

  var SEC = '.product-item-meta__title';
  var ISARET = 'data-rms-baslik';
  var AYRAC = '\u00b7';           // ·

  /* ILK SURUM BOZDU — 24 Eylul, ayni gun duzeltildi.
     el.textContent kullanmistim. Ama ALT SATIR (kordon · cap) da bu
     bagin ICINDE duruyor (olculdu: .product-item-meta__title bir <a> ve
     hem urun adini hem alt satiri tasiyor). textContent ikisini birden
     aliyor, ilk '·' isaretinden bolunce alt satir urun adina yapisti:
     "Rose KaplamaHakiki Deri · 42 mm".
     Dogrusu: yalnizca ILK METIN DUGUMUNU (urun adi) islemek, eleman
     cocuklarina (alt satir) hic dokunmamak. */
  function bol(el) {
    if (el.getAttribute(ISARET)) return;

    /* GERCEK YAPI (CDP ile olculdu):
         <a class="product-item-meta__title rms-cm">   display:flex, column
           <span class="rms-cm__main">Siyah Kadran · Rose Kaplama</span>
           <span class="rms-cm__sub">Hakiki Deri · 42 mm</span>
         </a>
       Yani urun adi ayri bir SPAN icinde, cıplak metin dugumu degil.
       Ilk iki denemem bu yuzden ya alt satiri yapistirdi (textContent)
       ya da hicbir sey bulamadi ('metin-yok'). Dogru hedef .rms-cm__main. */
    var kap = el.querySelector('.rms-cm__main');
    if (!kap) { el.setAttribute(ISARET, 'ad-yok'); return; }

    var dugum = null;
    for (var i = 0; i < kap.childNodes.length; i++) {
      var n = kap.childNodes[i];
      if (n.nodeType === 3 && (n.nodeValue || '').trim()) { dugum = n; break; }
    }
    if (!dugum) { el.setAttribute(ISARET, 'metin-yok'); return; }

    var metin = dugum.nodeValue.trim();
    var i2 = metin.indexOf(AYRAC);
    if (i2 < 0) { el.setAttribute(ISARET, 'tek-parca'); return; }

    var sol = metin.slice(0, i2).trim();
    var sag = metin.slice(i2 + 1).trim();
    if (!sol || !sag) { el.setAttribute(ISARET, 'bolunemez'); return; }

    var a = document.createElement('span');
    a.className = 'rms-bas-parca';
    a.textContent = sol + ' ' + AYRAC;
    var bosluk = document.createTextNode(' ');
    var b = document.createElement('span');
    b.className = 'rms-bas-parca';
    b.textContent = sag;

    // Yalnizca o metin dugumunu degistir; kardesleri yerinde kalir.
    dugum.parentNode.insertBefore(a, dugum);
    dugum.parentNode.insertBefore(bosluk, dugum);
    dugum.parentNode.insertBefore(b, dugum);
    dugum.parentNode.removeChild(dugum);
    el.setAttribute(ISARET, '1');
  }

  function tara() {
    var n = document.querySelectorAll(SEC);
    for (var i = 0; i < n.length; i++) bol(n[i]);
  }

  function baslat() {
    tara();
    var g = new MutationObserver(tara);
    g.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { g.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else {
    baslat();
  }
})();
